(ns teamoesterreich.admin-mode.admin-mode-core
  (:require
    [reagent.core :as r]

    [reagent-material-ui.components :as mui]
    [reagent-material-ui.styles :as styles]

    [reagent-material-ui.cljs-time-utils :refer [cljs-time-utils]]
    [teamoesterreich.style.toe-material-style :as m-style]

    [teamoesterreich.view-state :as vstate]
    [teamoesterreich.admin-mode.event-ws :as event-ws]
    [teamoesterreich.syncer :as sync]
    [teamoesterreich.util.log :as log]


    [teamoesterreich.admin-mode.navigation.app-bar :as app-bar]
    [teamoesterreich.admin-mode.navigation.drawer :as drawer]
    [teamoesterreich.admin-mode.navigation.bottom-bar :as bottom-bar]
    [teamoesterreich.admin-mode.page-router :as page-router]

    [teamoesterreich.web-path :as web-path])

  (:import (goog.i18n DateTimeSymbols_de_AT)))


(defn main []
  (let [!load-state (r/cursor vstate/app-state [:load-state])
        !actual-tom-id (r/cursor vstate/app-state [:actual-user :tom-id])]

    (js/console.log "main !!! " @!actual-tom-id (not= :finished @!load-state) (not= :loading @!load-state)
                    "--->" (and @!actual-tom-id (not= :finished @!load-state) (not= :loading @!load-state)))

    (when (and @!actual-tom-id (not= :finished @!load-state) (not= :loading @!load-state))
      (sync/get-all)
      (event-ws/start-event-listener 0)
      (web-path/load)
      )
    (js/console.log "Style " (clj->js m-style/toe-theme))
    (fn []
      [:<>
       [mui/css-baseline]
       [styles/theme-provider m-style/toe-mui-theme
        [(m-style/with-toe-styles app-bar/bar)]

        [drawer/drawer-menu]



        [(m-style/with-toe-styles page-router/get-page)]


        [bottom-bar/bar]
        ]])))



